import CouponList from "./CouponList";
import CouponEdit from "./CouponEdit";
import CouponCreate from "./CouponCreate";

export default {
    list: CouponList,
    edit: CouponEdit,
    create: CouponCreate,
};
